/* Dim Nook — Nightreader v3
   RoverOak-audit lessons baked in:
   - capture-phase double-submit guard w/ in-flight lock + failsafe release
   - sticky ATC after the gallery is scrolled past; bows out at the footer
   - accessible pickers (real buttons, aria-checked)
   - pack pricing mirrors the automatic BXGY deal exactly — never invented
   v3.2: 1/2/4 pack selector w/ per-light style tiles; adds N singles to cart */
(function () {
  'use strict';

  /* ---------- announcement rotator ---------- */
  var bar = document.getElementById('dn-rotbar');
  if (bar) {
    var msgs = bar.querySelectorAll('span');
    if (msgs.length > 1) {
      var mi = 0;
      setInterval(function () {
        msgs[mi].classList.remove('on');
        mi = (mi + 1) % msgs.length;
        msgs[mi].classList.add('on');
      }, 3600);
    }
  }

  var form = document.getElementById('dn-product-form');
  if (!form) return;

  /* ---------- gallery: slider (mobile) + thumbs (desktop) ---------- */
  var slider = document.getElementById('dn-slider');
  var slides = slider ? Array.prototype.slice.call(slider.querySelectorAll('.dn-slide')) : [];
  var dotsWrap = document.getElementById('dn-dots');
  var dots = [];

  function setActiveSlide(i, scrollIt) {
    slides.forEach(function (s, j) { s.classList.toggle('active', j === i); });
    dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
    document.querySelectorAll('[data-dn-thumb]').forEach(function (b, j) { b.classList.toggle('active', j === i); });
    if (scrollIt && slider) {
      var s = slides[i];
      if (s) slider.scrollTo({ left: s.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
    }
  }

  if (dotsWrap && slides.length > 1) {
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      if (i === 0) b.classList.add('active');
      b.addEventListener('click', function () { setActiveSlide(i, true); });
      dotsWrap.appendChild(b);
      dots.push(b);
    });
    var st;
    slider.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var w = slides[0] ? slides[0].offsetWidth + 10 : 1;
        var i = Math.round(slider.scrollLeft / w);
        i = Math.max(0, Math.min(slides.length - 1, i));
        dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
      }, 80);
    }, { passive: true });
  }

  document.querySelectorAll('[data-dn-thumb]').forEach(function (btn, i) {
    btn.addEventListener('click', function () { setActiveSlide(i, true); });
  });

  function showMediaId(mediaId) {
    var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
    if (idx >= 0) setActiveSlide(idx, true);
  }
  function swapToVariantPhoto(v) {
    if (!v) return;
    if (v.featured_media && v.featured_media.id) showMediaId(v.featured_media.id);
    else if (v.featured_image && v.featured_image.id) showMediaId(v.featured_image.id);
  }

  /* ---------- data ---------- */
  var variantsEl = document.querySelector('[data-dn-variants]');
  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var idInput = form.querySelector('[data-dn-variant-id]');
  var DEAL_OFF = 1995; /* cents off every 2nd light — mirrors the BXGY discount */

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function money0(cents) { return money(cents).replace('.00', ''); }
  function variantById(id) {
    return variants.find(function (v) { return String(v.id) === String(id); });
  }

  /* ---------- pack state ---------- */
  var packCards = Array.prototype.slice.call(document.querySelectorAll('[data-dn-pack]'));
  var activeQty = packCards.length ? parseInt(packCards[0].dataset.dnPack, 10) : 1;
  var slotSel = {};
  packCards.forEach(function (card) {
    var qty = parseInt(card.dataset.dnPack, 10);
    var slots = Array.prototype.slice.call(card.querySelectorAll('.dn-slot'));
    if (slots.length) {
      slotSel[qty] = slots.map(function (slot, i) {
        var tiles = slot.querySelectorAll('.sl-tile');
        var pick = variants[i % variants.length];
        tiles.forEach(function (t) {
          t.classList.toggle('active', String(pick.id) === t.dataset.variantId);
        });
        return pick.id;
      });
    }
  });

  function mainPickerVariant() {
    var sel = {};
    document.querySelectorAll('.dn-styleopt.active').forEach(function (b) {
      sel[b.dataset.optionIndex] = b.dataset.value;
    });
    return variants.find(function (v) {
      return Object.keys(sel).every(function (idx) { return v['option' + idx] === sel[idx]; });
    }) || variants[0];
  }

  function refreshBuy() {
    var p = document.querySelector('[data-dn-price]');
    var c = document.querySelector('[data-dn-compare]');
    var sv = document.querySelector('[data-dn-save]');
    var label = document.querySelector('[data-dn-atc-label]');
    var sp = document.querySelector('[data-dn-sticky-price]');
    var atc = document.getElementById('dn-atc');
    var priceC, compareC;
    if (activeQty === 1) {
      var v = mainPickerVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      priceC = v.price;
      compareC = v.compare_at_price || 0;
      if (atc) atc.disabled = !v.available;
      if (label) label.textContent = v.available ? 'Add to Cart — ' + money(priceC) : 'Sold out';
    } else {
      var sum = (slotSel[activeQty] || []).reduce(function (a, id) {
        var vv = variantById(id);
        return a + (vv ? vv.price : 0);
      }, 0);
      priceC = sum - Math.floor(activeQty / 2) * DEAL_OFF;
      compareC = sum;
      if (atc) atc.disabled = false;
      if (label) label.textContent = 'Add ' + activeQty + ' to Cart — ' + money(priceC);
    }
    if (p) p.textContent = money(priceC);
    if (c) c.textContent = compareC > priceC ? money(compareC) : '';
    if (sv) {
      if (compareC > priceC) { sv.textContent = 'Save ' + money0(compareC - priceC); sv.style.display = ''; }
      else sv.style.display = 'none';
    }
    if (sp) sp.textContent = money(priceC);
  }

  function selectPack(qty) {
    activeQty = qty;
    packCards.forEach(function (card) {
      var on = parseInt(card.dataset.dnPack, 10) === qty;
      card.classList.toggle('active', on);
      card.setAttribute('aria-pressed', String(on));
    });
    refreshBuy();
  }

  packCards.forEach(function (card) {
    var qty = parseInt(card.dataset.dnPack, 10);
    function activate() { selectPack(qty); }
    card.addEventListener('click', activate);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
    });
    card.querySelectorAll('.dn-slot').forEach(function (slot, slotIdx) {
      slot.querySelectorAll('.sl-tile').forEach(function (tile) {
        tile.addEventListener('click', function (e) {
          e.stopPropagation();
          slotSel[qty][slotIdx] = parseInt(tile.dataset.variantId, 10);
          slot.querySelectorAll('.sl-tile').forEach(function (t) {
            t.classList.toggle('active', t === tile);
          });
          if (slotIdx === 0) swapToVariantPhoto(variantById(tile.dataset.variantId));
          selectPack(qty);
        });
      });
    });
  });

  /* ---------- main style picker (drives the single) ---------- */
  document.querySelectorAll('[data-dn-option]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.dn-styles');
      group.querySelectorAll('[data-dn-option]').forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-checked', 'true');
      var nameEl = group.previousElementSibling.querySelector('[data-dn-optname]');
      if (nameEl) nameEl.textContent = btn.dataset.value;
      var v = mainPickerVariant();
      swapToVariantPhoto(v);
      selectPack(1);
    });
  });

  /* ---------- add-to-cart: single-flight guard, multi-item packs ---------- */
  var isAdding = false;
  var atcBtn = document.getElementById('dn-atc');
  var stickyBtn = document.getElementById('dn-sticky-btn');

  function currentItems() {
    var ids;
    if (activeQty === 1) ids = [parseInt(idInput.value, 10)];
    else ids = (slotSel[activeQty] || []).map(function (id) { return parseInt(id, 10); });
    var counts = {};
    ids.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
    return Object.keys(counts).map(function (id) {
      return { id: parseInt(id, 10), quantity: counts[id] };
    });
  }

  function setAdding(state) {
    isAdding = state;
    [atcBtn, stickyBtn].forEach(function (b) {
      if (!b) return;
      b.disabled = state;
      if (b === stickyBtn) b.textContent = state ? 'Adding…' : 'Add to Cart';
    });
    var label = document.querySelector('[data-dn-atc-label]');
    if (label && state) label.textContent = 'Adding…';
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (isAdding) return;            /* capture the double-tap */
    setAdding(true);
    var failsafe = setTimeout(function () { setAdding(false); }, 4000);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: currentItems() })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        var count = document.querySelector('[data-dn-cart-count]');
        if (count) count.textContent = cart.item_count;
        clearTimeout(failsafe);
        setAdding(false);
        refreshBuy();
        if (document.getElementById('dn-drawer')) {
          document.dispatchEvent(new CustomEvent('dn:cart:added'));
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        clearTimeout(failsafe);
        setAdding(false);
      });
  }, true); /* capture phase */

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (isAdding) return;
      form.requestSubmit();
    });
  }

  /* ---------- sticky bar: after the gallery, never over the footer ---------- */
  var sticky = document.getElementById('dn-sticky');
  var gallery = document.getElementById('dn-gallery');
  var footer = document.querySelector('.dn-footer');
  if (sticky && gallery && 'IntersectionObserver' in window) {
    var pastGallery = false, footerVisible = false;
    var syncSticky = function () {
      var show = pastGallery && !footerVisible;
      sticky.classList.toggle('show', show);
      sticky.setAttribute('aria-hidden', String(!show));
    };
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      pastGallery = !e.isIntersecting && e.boundingClientRect.top < 0;
      syncSticky();
    }, { threshold: 0 }).observe(gallery);
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        syncSticky();
      }, { threshold: 0 }).observe(footer);
    }
  }

  refreshBuy();
})();
